<img
    *ngIf="type === 'image' && sourceUrl && !imageMissing"
    class="document-viewer__image"
    [ttImageSrc]="sourceUrl"
    [alt]="file?.fileName || file?.localFileName || ''"
    (ttImageSrcError)="onImageError()"
    (error)="onImageError()"
/>

<iframe *ngIf="type === 'pdf' && frameUrl" class="document-viewer__frame" [src]="frameUrl"></iframe>

<tt-office-document-viewer
    *ngIf="type === 'office' && file?.fileItemId"
    [documentId]="file?.fileItemId || ''"
    [canConvert]="canConvert"
    (conversionCompleted)="officeConversionCompleted.emit($event)"
></tt-office-document-viewer>

<tt-email-viewer *ngIf="type === 'email'" [emailKeyno]="emailKeyno"></tt-email-viewer>
